import React from 'react';

const BackToTop = () => (
  <div className="ft-backToTop">
    <a href="#react-view" className="ft-backToTop__link">Back to top</a>
  </div>
);

export default BackToTop;
